import { render, staticRenderFns } from "./provider-item-details.vue?vue&type=template&id=c3a2b6c0&scoped=true"
import script from "./provider-item-details.vue?vue&type=script&lang=js"
export * from "./provider-item-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a2b6c0",
  null
  
)

export default component.exports